import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { MyInterestsFormService } from '@modules/private/services/my-interests-form.service';
import { first, shareReplay, switchMap, withLatestFrom } from 'rxjs/operators';
import { User } from '@core/modules/user/models';
import { BaseOption } from '@shared/models/base-option';

@Component({
    selector: 'app-my-intenersts-form',
    templateUrl: './my-interersts-form.component.html',
    styleUrls: ['./my-interersts-form.component.scss'],
    standalone: false
})
export class MyIntererstsFormComponent implements OnInit {
  @Input() user!: Observable<User | undefined>;
  @Input() navigationBackButton = false;
  @Input() label!: string;

  @Output() navigationBack = new EventEmitter<void>();
  @Output() interestsSubmit = new EventEmitter<{ interests: number[] }>();

  interests$!: Observable<BaseOption[]>;
  interestsForm!: UntypedFormGroup;

  constructor(private myInterestsFormService: MyInterestsFormService) {}

  ngOnInit(): void {
    this.interests$ = this.user.pipe(
      first(),
      switchMap((user) => this.getInterests(user)),
      shareReplay({ bufferSize: 1, refCount: true })
    );

    this.interests$
      .pipe(withLatestFrom(this.user))
      .subscribe(([interests, user]) => (this.interestsForm = this.initForm(interests, user)));
  }

  onSubmit(): void {
    this.interestsForm.valid &&
      this.interestsSubmit.emit({
        interests: this.myInterestsFormService.getSelectedInterestsIds(this.interestsForm.value)
      });
  }

  onBack(): void {
    this.navigationBack.emit();
  }

  private initForm(interests: BaseOption[], user?: User | undefined): UntypedFormGroup {
    return new UntypedFormGroup(this.getFormControls(interests, user), {
      validators: this.myInterestsFormService.interestsValidator()
    });
  }

  private getFormControls(
    interests: BaseOption[],
    user?: User | undefined
  ): { [key: string]: UntypedFormControl } {
    return interests.reduce(
      (_interests, interest) => ({
        ..._interests,
        [interest.id.toString()]: new UntypedFormControl(
          user?.interests.includes(interest.id as number)
        )
      }),
      {}
    );
  }

  private getInterests(user: User | undefined): Observable<{ name: string; id: number }[]> {
    return this.myInterestsFormService
      .getDevicesInterests(this.myInterestsFormService.getDevicesIds(user))
      .pipe(shareReplay({ bufferSize: 1, refCount: true }));
  }
}
